<template>
  <app-layout>
    <template slot="endDrawerMenu">
      <v-list-tile @click="logout">
        <v-list-tile-action class="pr-0">
          <v-icon v-html="'mdi-close-outline'"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="caption font-weight-medium">
            {{ $t('Cerrar sesión') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <dashboard-layout>
      <template slot="header"></template>
      <template slot="header-out">
        <div v-if="userFiscalData">
          <customer-data-form
            no-close-button
            :title="$t('Datos de mi negocio')"
            v-if="configLoaded"
            :config="config"
            :edit-item="userFiscalData"
            :show-contract-data-tab="false"
            :show-users-tab="false"
            :show-additional-data-tab="false"
          ></customer-data-form>
        </div>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import ApiCtrl from '@/services/api/abstract/abstract-api.js';
import CustomerDataForm from '@/modules/admin/aplifisa/components/CustomerDataForm.vue';

export default {
  components: {
    AppLayout,
    CalendarEvents,
    MyConsultantConversation,
    DashboardLayout,
    CustomerDataForm,
  },

  data() {
    return {
      configLoaded: false,
      config: {},
      editedItem: {},
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getConfig() {
      this.configLoaded = false;
      ApiCtrl.get('/config/fiscaldata').then(res => {
        console.log({ config: res });
        this.config = res.data.data;
        this.configLoaded = true;
      });
    },
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    userCompanies() {
      if (
        this.user.hasOwnProperty('customer_profile') &&
        this.user.customer_profile.hasOwnProperty('fiscal_data') &&
        this.user.customer_profile.fiscal_data.length
      ) {
        return this.user.customer_profile.fiscal_data;
      } else {
        return [];
      }
    },
    userFiscalData() {
      let result = this.userCompanies[0];
      this.userCompanies.forEach(company => {
        console.log({
          company: company,
          clavedat: this.clavedat,
          comp_clavedat: company.CLAVEDAT,
        });
        if (Number(company.CLAVEDAT) === Number(this.clavedat)) {
          result = company;
        }
      });

      return result;

      // if(this.user.hasOwnProperty('customer_profile') && this.user.customer_profile.hasOwnProperty('fiscal_data') && this.user.customer_profile.fiscal_data.length) {
      //     this.user.customer_profile.fiscal_data.forEach(element => {

      //     });
      //     console.log({MYPROFILE: this.user.customer_profile.fiscal_data[0]});
      //     return this.user.customer_profile.fiscal_data[0];
      // } else {
      //     return null;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list {
  &__tile {
    &__action {
      min-width: 35px;
    }
  }
}
</style>
